import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import {MaskDefault} from "../../../../utils/mask.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <div>
                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div>
                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div>
                        <InputForm
                            label="Placa anterior"
                            value={filters.plate}
                            mask={MaskDefault.plateNoRestrict}
                            onChange={({target}) => setFilters(prev => ({ ...prev, plate: target.value?.toUpperCase() }))}
                            instanceId="plate"
                            id="plate"
                            classNameWrapper={"w-full"}
                            autocomplete={'off'}
                        />
                    </div>

                    <div>
                        <InputForm
                            label="Placa corrigida"
                            value={filters.newPlate}
                            mask={MaskDefault.plateNoRestrict}
                            onChange={({target}) => setFilters(prev => ({ ...prev, newPlate: target.value?.toUpperCase() }))}
                            instanceId="newPlate"
                            id="newPlate"
                            classNameWrapper={"w-full"}
                            autocomplete={'off'}
                        />
                    </div>

                    <AccessForm filters={filters} setFilters={setFilters}/>

                </form>
            </div>
        </>
    );
};

export default Filters;